import { axios } from '@Root/API'

export const remove = (contactId, admissionsId) => {
  return axios.delete(`get/contact/${contactId}/admission/${admissionsId}`)
}
